var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1639530746096,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15743,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M957 782.2h-29.7c-4.9 0-9 4-9 8.9v79.3c0 19.5-22.7 42.2-42.2 42.2h-80.7c-4.9 0-9 4-9 8.9v29.8c0 4.9 4 9 8.9 9H876c49.5-0.1 89.6-40.2 89.8-89.7v-79.2c0.2-4.8-3.6-8.9-8.4-9.1-0.1-0.1-0.2-0.1-0.4-0.1zM240.2 62.1h-82.1c-49.5 0.2-89.6 40.3-89.8 89.8v83.6c0 5 4 9 8.9 9H107c4.9 0 9-4 9-8.9V151.9c0-19.5 22.7-42.2 42.2-42.2h82.1c4.9 0 9-4 9-8.9V71.1c-0.2-4.9-4.2-8.9-9.1-9zM876.1 62.1h-80.5c-4.9 0-9 4-9 8.9v29.8c0 4.9 4 9 8.9 9H876.2c19.5 0 42.2 22.7 42.2 42.2v83.5c0 4.9 4 9 8.9 9H957c4.9 0 9-4 9-8.9V152c-0.2-49.6-40.3-89.7-89.9-89.9zM240.2 912.4h-82.1c-19.5 0-42.2-22.7-42.2-42.2V791c0-4.9-4-9-8.9-9H77.2c-4.9 0-9 4-9 8.9v79.3c0.1 49.5 40.2 89.7 89.8 89.9h82.1c4.9 0 9-4 9-8.9v-29.8c0-4.9-4-8.9-8.9-9zM517.2 803.6h281.7s-0.1-65.7-4.6-76.3c-4.6-10.6 2.4-20.2-20.4-29.8-33.7-14.2-127.1-49.7-136.7-52.3-11.4-8-15.5-34.1-13.3-48.6l-37.8-3.1c9.1-12.4 27.9-22.2 32.6-36 4.7-13.8 6.6-39.3 8.4-57.5 3.5-0.4 11.1-2.7 12.8-3.7 17.7-11.2 28.7-54.6 22.7-72.4-3.1-9.2-20-2.2-15.1-20.5 27.2-102-13.8-156.9-57.9-171.2-18.5-7.5-41.3-16.7-72.5-17.3-31.2 0.6-54 9.8-72.5 17.3-44 14.3-85.1 69.2-57.9 171.2 4.9 18.3-12.1 11.3-15.1 20.5-6 17.8 5 61.2 22.7 72.4 1.7 1.1 9.2 3.4 12.8 3.7 1.8 18.2 3.7 43.8 8.4 57.5 4.8 13.8 23.6 23.6 32.6 36l-37.8 3.1c2.2 14.5-1.9 40.7-13.3 48.6-9.6 2.6-58.1 38.1-91.8 52.3-22.9 9.6-60.8 19.2-65.3 29.8-4.5 10.6-4.7 76.3-4.7 76.3h282z m0 0",
    "p-id": 15744,
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceLogin);
export default __webpack_public_path__ + "static/media/faceLogin.942e9e18.svg";
export { ForwardRef as ReactComponent };